import { ObservableQuery } from '@apollo/client';
import {
  OrganisationMember,
  OrganisationRole,
} from '@ih/app/shared/apis/interfaces';

export class FindAllDefaultRolesSuccess {
  public static readonly type =
    '[Organisation/OrganisationRoles/List] FindAllDefaultRolesSuccess';
  constructor(
    public readonly result: ObservableQuery.Result<{
      listCoreOrganisationRoles: OrganisationRole[];
    }>,
    public readonly members: OrganisationMember[],
  ) {}
}
